<template>
  <div class="step2">
    <div class="content">
      <div>
        为保证您的账号及财产安全，在您提交注销申请时，请确保您申请注销的账号已经同时满足以下条件：
      </div>
      <div>1.该账号为您本人合法拥有并登录使用；</div>
      <div>
        2.账号处于安全及正常使用状态，且无被封、被盗等风险；
      </div>
      <div>
        3.相关游戏收益已结清或得到妥善处理：包括但不限于点券、钻石、金币、道具、体验卡、会员权益及其他游戏收益等；若注销时未处理，视为您自愿放弃该等收益;
      </div>
      <div>
        4.无未完成状态订单：包括但不限于基于该账号产生的有关网络游戏虚拟货币、虚拟道具、周边商品等的订单；
      </div>
      <div>
        5.
        账号无任何纠纷：包括投诉举报、被投诉举报、国家机关调查、仲裁、诉讼等纠纷。
      </div>
    </div>
    <!-- <div class="divider"></div> -->
    <div class="next-step w-full">
      <div class="agree-radio">
        <van-checkbox checked-color="#FF6600" v-model="checked"></van-checkbox>
        <div>我已仔细阅读并满足注销细则要求</div>
      </div>
      <Button
        :disabled="!checked"
        @click="goToNextStep"
        class="default-xd-button"
        text="下一步"
      />
    </div>
  </div>
</template>

<script>
// import Input from '../../components/input'
import Button from '../../components/button'
import { Toast } from 'vant'

export default {
  props: {
    nextStep: {
      type: Function,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeHolder: '请输入你的心动 IDxxx',
      value: '',
      checked: false
    }
  },
  components: {
    Button
  },
  mounted () {
    if (!window.user_id) {
      this.$router.push({ name: 'Home', hash: '#step1', params: { index: 2 } })
    }
  },
  methods: {
    goToNextStep () {
      if (!this.checked) {
        Toast('您必须同意帐号注销细则!')
        window.cancelDetails = null
        return
      }
      this.$emit('nextStep')
      window.cancelDetails = true
    },
    onInputChange (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="less" scoped>
.divider {
  position: fixed;
  height: 1px;
  width: 900px;
  margin-left: -99px;
  background-color: #8a8a8a1f;
  bottom: 145px;
}
.step2 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .content {
    margin-top: 16px;
    text-align: left;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */
    text-align: justify;
    letter-spacing: 4.93507e-9px;
    /* 正文 */
    color: #5c5c5c;
  }
  .next-step {
    margin-top: 51px;
    height: 124px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .agree-radio {
      width: 100%;
      .van-checkbox {
        margin-right: 8px;
      }
      display: flex;
      flex-direction: row;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      /* or 171% */
      /* 黑色 */
      color: #333333;
      /* Inside Auto Layout */
      flex-grow: 0;
      margin: 8px 0px;
    }
    button {
      margin-top: 20px;
      width: 100%;
    }
  }
}
</style>
